(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nms-product-features"] && !Shopify.designMode) return;
  try {
    
  (function() {
    try {
      document.querySelectorAll('.nms-product-features__desc').forEach(function(wrapper){
        var content = wrapper.querySelector('.nms-product-features__desc-content');
        var toggle = wrapper.querySelector('.nms-product-features__toggle');
        if (!content || !toggle) return;
        // Force layout to measure
        var isOverflowing = content.scrollHeight > content.clientHeight + 1;
        if (!isOverflowing) {
          wrapper.classList.add('nms-product-features__desc--no-toggle');
          var expander = wrapper.querySelector('.nms-product-features__expander');
          if (expander) expander.checked = false;
        }
      });
    } catch (e) { /* no-op */ }
  })();

  } catch(e) { console.error(e); }
})();
})();
